export default {
  inheritAttrs: false,

  data () {
    return {
      isResetted: true,
    };
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: [String, null],
      required: false,
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    helper: {
      type: String,
      default: null,
    },
    info: {
      type: [String, Object],
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    readonly: {
      type: Boolean,
      default: false,
      required: false,
    },
    validation: {
      type: [Object, null],
      required: false,
      default: null,
    },
    validationMessages: {
      type: Function,
      required: false,
      default: null,
    },
    disabled: {
      type: [Boolean, Function],
      required: false,
      default: false,
    },
  },

  computed: {
    isRequired () {
      if (this.required === true) {
        return true;
      }

      return this.validation && this.validation.required !== undefined;
    },

    validationValue: {
      get () {
        return this.validation;
      },
      set (v) {
        this.$emit('input', v);
      },
    },

    fieldClasses () {
      const classes = [];
      if (this.validation && this.validation.$error === true) {
        classes.push('form__item--error');
      }

      if (this.validation && this.validation.$invalid === false) {
        classes.push('form__item--valid');
      }

      return classes;
    },
  },
  methods: {
    getValue () {
      return this.value;
    },
    isDisabled (v) {
      if (this.disabled === true) {
        return true;
      }

      if (typeof this.disabled === 'function') {
        return this.disabled(v);
      }

      return false;
    },
    onBlur () {
      if (this.validation) {
        this.validation.$touch();
        this.isResetted = false;
      }
    },
    onInput (event) {
      if (!this.isResetted) {
        this.validation.$reset();
        this.isResetted = true;
      }

      this.$emit('input', `${event.target.value}`);
    },
  },
};
